export default "__VITE_ASSET__CsoLxJ1f__"